
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
           
    color:'#fff',
    name:'Verarbeitung',
    showminies: true,
    showmedia: false,
    vuexnamespace: 'treatments',
    initmutation:'treatments/TREATMENT_INIT_TREATMENT',
    backlink:'entities',
    duplicateable:true,
    helptext:"Hier werden die Vorverarbeitungsschritte (würfeln, hacken) eingegeben <br><br> Der goldene Haken dient der Speicherung. Mit dem schwarzen Kreuz\n\
            wird ohne zu speichern das Formular verlassen. Mit dem Doppelhaken wird der Datensatz dupliziert."
                                                   
    
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};